import React = require('react');
import { useEffect, useState } from 'react';
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../redux/IStore';
import { ICustomerMTAOptions } from '../../MakeAChange';

interface ICarousel {
  data: IcarouselData[]
  animate?: boolean
  customerMTAOptions: ICustomerMTAOptions
}

export interface IcarouselData {
  component: any;
  backgroundColor?: string;
  navBackGround?: string;
}

const Carousel = ({ data, customerMTAOptions, animate = false }: ICarousel) => {

  const [currentIndex, setCurrentIndex] = useState(0)
  const [touchStartPosition, setTouchStartPosition] = useState(0);
  const [touchEndPosition, setTouchEndPosition] = useState(0);
  const [touched, setTouched] = useState(false);
  const [swiped, setSwiped] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  const animationSpeed = customerMTAOptions?.other?.carousel_animation_speed || 5000;

  // Function to start the interval
  const startInterval = () => {
    const id = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
    }, animationSpeed);
    setIntervalId(id);
  };

  // Function to clear the interval
  const clearIntervalFunction = () => {
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
  };

  const resetInterval = () => {
    clearIntervalFunction();
    startInterval();
  }

  useEffect(() => {

    if (!animate) {
      return;
    }

    startInterval(); // Change slide every 5 seconds

    return () => clearIntervalFunction(); // Cleanup interval on component unmount
  }, [data.length]);

  const carouselBackWardScroll = () => {
    if (currentIndex !== 0) {
      setCurrentIndex(currentIndex - 1)
    }
    resetInterval();
  }

  const carouselForwardScroll = () => {
    if (currentIndex < data.length - 1) {
      setCurrentIndex(currentIndex + 1)
    }
    resetInterval();
  }

  const touchStartHandler = (e) => {
    setTouchStartPosition(e.targetTouches[0].clientX);
    setTouchEndPosition(e.targetTouches[0].clientX);
    setTouched(true);
  }
  const touchMoveHandler = (e) => {
    setTouchEndPosition(e.targetTouches[0].clientX);
    if (touched === true) {
      setSwiped(true);
    }
  }

  const touchEndHandler = () => {
    if (swiped) {
      if (isSwipeForward()) {
        carouselForwardScroll();
      } else if (isSwipeBackward()) {
        carouselBackWardScroll();
      }
    }
    setTouched(false);
    setSwiped(false);
  }

  const isSwipeBackward = () => {
    return touchStartPosition - touchEndPosition < -75;
  }

  const isSwipeForward = () => {
    return touchStartPosition - touchEndPosition > 75;
  }

  const navColor = data[currentIndex].navBackGround || '#0059a9'

  return (
    <>
      <div className={'carousel-container'} style={{ backgroundColor: data[currentIndex].backgroundColor }}>
        {currentIndex > 0 &&
          <div className={'carousel-back'}
               style={{ backgroundColor: navColor }}
               onClick={carouselBackWardScroll}/>
        }

        {data.map((item: IcarouselData, index) => {
          let display;


          switch (typeof item.component) {
            case 'function':
              display = item.component();
              break;
            default:
              display = item.component;
          }

          return (
            <div className={'carousel-item'}
                 style={{ transform: `translate(-${currentIndex * 100}%)` }}
                 key={index}>
              <div
                onTouchStart={touchStartHandler}
                onTouchMove={touchMoveHandler}
                onTouchEnd={touchEndHandler}>
                {display}
              </div>
            </div>
          )
        })}
        <>
          {(currentIndex < data.length - 1) &&
            <div
              className={'carousel-forward'}
              style={{ backgroundColor: navColor }}
              onClick={carouselForwardScroll}/>
          }

        </>
      </div>
      <div className={'carousel-navigator'}>
        {data.map((item, index) => {
          return (
            <div className={currentIndex === index ? 'navigator-element selected' : 'navigator-element'} key={index}/>
          )
        })}
      </div>
    </>
  )

}

export default flow([
  connect(
    (state: IStore) => {
      return {
        customerMTAOptions: get(state.branding.channel.products[0], 'metadata.direct_customer_mta_options', null),
      };
    },
  ),
])(Carousel);
